module.exports = __webpack_public_path__ + "static/media/logo-terna-spa.327ddc2c.png";